{
	"accept": {
		"cancel": "Annulla",
		"confirm_one": "Sì, accetta la riga",
		"confirm_other": "Sì, accetta {{rows}} righe",
		"confirm_view_description_one": "L’altra riga della proposta d’ordine non viene toccata. Le righe già corrette non cambiano e l’azione resta tracciata nello storico.",
		"confirm_view_description_other": "Le altre {{others}} righe della proposta d’ordine non vengono toccate. Le righe già corrette non cambiano e l’azione resta tracciata nello storico.",
		"confirm_view_title_one": "Accettare la riga di questa vista?",
		"confirm_view_title_other": "Accettare le {{rows}} righe di questa vista?",
		"confirm_whole_description_one": "Verrà accettata l’ultima riga ancora da rivedere, anche se segnalata. L’azione resta tracciata nello storico.",
		"confirm_whole_description_other": "Verranno accettate tutte le {{rows}} righe ancora da rivedere, comprese quelle segnalate. L’azione resta tracciata nello storico.",
		"confirm_whole_title_one": "Accettare l’ultima riga da rivedere?",
		"confirm_whole_title_other": "Accettare tutte le {{rows}} righe da rivedere?",
		"view_button": "Accetta questa vista ({{rows}})",
		"whole_button": "Accetta tutto ({{rows}})"
	},
	"breakdown": {
		"title": "Il calcolo, passo per passo"
	},
	"calc": {
		"hide_basis": "Nascondi la provenienza",
		"show_basis": "Da dove escono questi numeri"
	},
	"config": {
		"effect_notice": "Le modifiche hanno effetto dalle proposte successive: le proposte d’ordine già generate non cambiano.",
		"example_label": "Esempio",
		"history_entry": "Configurazione salvata",
		"history_load_more": "Carica di più",
		"history_system": "Modifica automatica",
		"history_title": "Storia delle modifiche",
		"invalid_month_day": "Inserisci una data valida nel formato gg/mm, per esempio 30/09.",
		"invalid_number": "Inserisci un numero valido.",
		"invalid_percentage": "Inserisci una percentuale tra 0 e 100.",
		"no_changes": "Nessuna modifica da salvare",
		"page_title": "Impostazioni",
		"remove": "Rimuovi",
		"safety_default": "Scorta standard",
		"safety_description": "La percentuale si applica alle copie ancora da servire nel periodo coperto dalla proposta d’ordine, comprese le richieste clienti che fissano il fabbisogno minimo. Giacenza e copie già ordinate al fornitore vengono sottratte dopo. «Standard» vale per gli editori senza esclusiva, «Esclusive» per quelli configurati in esclusiva. Le condizioni di reso, compresi limiti e scadenze, vanno verificate con ciascun fornitore.",
		"safety_esclusiva": "Scorta per esclusive",
		"safety_example": "Su 200 copie ancora da servire, il 3% aggiunge 6 copie di scorta al fabbisogno. Poi si sottraggono magazzino e arrivi e si applicano gli arrotondamenti.",
		"safety_title": "Scorte di sicurezza",
		"save": "Salva configurazione",
		"sections_label": "Sezioni della configurazione",
		"tuning": {
			"adoption_description": "Come le sezioni che adottano un titolo diventano copie da ordinare. Non c’è un numero unico: da una sezione adottante Mantegna assorbe 6,6 copie nel Lazio e 0,66 in Campania, e dentro la stessa regione cambia da editore a editore (Zanichelli in Campania 0,20, Petrini 3,44). Il motore quindi somma le sezioni regione per regione, ognuna al suo valore reale per quell’editore e quella tipologia scolastica: lo stesso conto che si fa a mente guardando dove si vende davvero. La «prudenza» evita che una coppia regione/editore con pochissime adozioni faccia testo da sola: sotto quelle sezioni di storico conta anche il dato medio della regione. I due limiti sono una rete di sicurezza sui casi estremi.",
			"adoption_example": "Un titolo con 226 sezioni nel Lazio e 572 in Campania non vale 798 × la media nazionale, ma 226 × 9,43 più 572 × 3,61.",
			"adoption_title": "Adozioni scolastiche",
			"adoptionBookingCap": "Proiezione massima del prenotato (0 = spenta)",
			"adoptionBookingMin": "Copie prenotate minime per proiettare",
			"adoptionCellPrior": "Prudenza sui dati sottili (sezioni)",
			"adoptionRegionWeighting": "Valuta le sezioni zona per zona",
			"adoptionWeightMax": "Scarto massimo ammesso dalla media",
			"adoptionWeightMin": "Scarto minimo ammesso dalla media",
			"adottatoHistoryThreshold": "Copie proprie sotto cui affidarsi all’adozione",
			"age": "{{n}} anni",
			"blend_description": "Come le vendite reali di quest’anno correggono la previsione fatta sullo storico. Funziona in due direzioni. Al rialzo, sempre: un titolo che ha già venduto più della sua previsione viene subito rialzato (le copie già vendute sono un minimo certo). Il «rialzo massimo» limita quanto si proietta il già venduto a fine anno, e si riduce da solo man mano che la stagione avanza. Al ribasso, con prudenza: la previsione viene abbassata verso il ritmo reale solo quando è trascorsa abbastanza stagione («stagione minima trascorsa»), perché a inizio stagione un venduto basso non significa calo. La «forza della correzione» regola quanto pesa il ritmo reale.",
			"blend_example": "Un titolo con previsione 49 che ha già venduto 1.400 copie a luglio viene rialzato a ~2.800; uno che a luglio ha venduto poco resta alla previsione storica.",
			"blend_title": "Correzione con le vendite di quest’anno",
			"blendK": "Forza della correzione",
			"blendMinElapsed": "Stagione trascorsa prima di attivarla",
			"campaignAnticipoShare": "Quota di anticipo campagna (0-1)",
			"coexistMinYearGap": "Anni minimi tra due edizioni per segnalare un doppione (0 = spento)",
			"edizioneRecenteMaxAge": "Anni massimi dall’uscita",
			"edizioneRecenteMinVol": "Copie già vendute (minimo)",
			"exclusivityFactorMax": "Fattore massimo per un'esclusiva acquisita (3 = fino a ×3)",
			"exclusivityFactorMin": "Fattore minimo per un'esclusiva persa (0-1, 0,1 = fino a −90%)",
			"fitMinBase": "Copie minime per usare un titolo nei calcoli",
			"leadTimeDays": "Giorni di consegna del fornitore",
			"lot_add_step": "Aggiungi gradino",
			"lot_description": "Arrotonda le quantità proposte a numeri ordinabili sensati, per evitare cifre come 47 o 183 scomode da gestire. Sotto la soglia «la lascio esatta» la quantità non viene toccata (poche copie, meglio precise); sopra quella soglia, viene arrotondata a seconda di quanto è grande l’ordine. Le regole dicono «fino a quale quantità» usare «quale arrotondamento»: gli ordini piccoli si arrotondano a numeri piccoli, quelli grandi a numeri più grossi.",
			"lot_example": "Con le regole predefinite, 47 diventa 50, 138 diventa 150, 640 diventa 650.",
			"lot_step_final": "oltre",
			"lot_step_step": "Passo",
			"lot_step_upto": "Fino a",
			"lot_steps_label": "Regole di arrotondamento",
			"lot_title": "Arrotondamento delle quantità",
			"lotExactBelow": "Sotto questa quantità la lascio esatta",
			"lotMinRecurring": "Confezione minima",
			"recent_description": "Riconosce i titoli usciti da poco, che non hanno ancora abbastanza storico per una previsione affidabile. Un titolo viene marcato come «appena uscito» quando la sua edizione è più giovane degli anni massimi indicati e ha già superato le copie minime vendute: abbastanza nuovo da trattarlo come un debuttante, ma con vendite sufficienti a meritare attenzione.",
			"recent_example": "Un titolo uscito l’anno scorso che ha già venduto 150 copie viene marcato come appena uscito.",
			"recent_title": "Titoli appena usciti",
			"regimes_description": "La proposta d’ordine «campagna» anticipa la quota indicata del fabbisogno annuo residuo (1 = tutto, 0,5 = metà). Il «riordino» copre il periodo scelto alla creazione più i giorni configurati per la consegna, da verificare con il fornitore. Nel riordino si applica una copertura iniziale più ampia ai titoli stimati dalle adozioni o dal passaggio di classe, oppure adottati senza sezioni nella campagna precedente, finché carichi e arrivi non raggiungono la quota iniziale: tutta la previsione per gli editori in esclusiva, la quota indicata per gli altri. Per tutti gli editori, inclusi quelli in esclusiva, questa copertura vale fino alla data configurata inclusa (30/09 come valore predefinito), confrontata con la data dei dati del round. Dal giorno successivo alla data configurata (quindi dal 1° ottobre con il valore predefinito) si usa il normale riordino, con le vendite recenti disponibili e le richieste clienti non consegnate, senza minimo iniziale. La regola può riguardare anche libri già venduti negli anni scorsi. Il fabbisogno copre almeno le richieste clienti non consegnate; giacenza e copie già ordinate al fornitore, registrate nel contatore RIFORN, vengono sottratte. Per le elementari, dal 1° ottobre incluso fino all’ultimo giorno di febbraio incluso, sia in campagna sia in riordino si coprono soltanto le richieste clienti non consegnate, al netto di giacenza e RIFORN, senza scorta né arrotondamenti in eccesso. Il vincolo prosegue oltre il cambio d’anno e comprende il 29 febbraio negli anni bisestili. Dal 1° marzo riprendono gli acquisti per scorta secondo le regole ordinarie.",
			"regimes_example": "A fine luglio un riordino a 14 giorni copre l’inizio del picco di agosto; lo stesso a febbraio proporrebbe quasi zero.",
			"regimes_title": "Campagna e riordini",
			"reorderHorizonDays": "Giorni coperti da un riordino",
			"reorderNewTitleShare": "Quota iniziale fuori esclusiva (0-1)",
			"reorderNewTitleUntil": "Copertura iniziale per tutti gli editori fino al (gg/mm)",
			"retCeil": "Rivendita massima (limita anche adozioni e passaggio di classe)",
			"retention_description": "Indica quante delle copie vendute l’anno scorso ci si aspetta di rivendere quest’anno, a seconda di quanto è vecchia l’edizione. Il valore 1,00 vuol dire «stesse vendite dell’anno scorso», sopra 1 vuol dire in crescita, sotto 1 in calo: i titoli appena usciti (0-1 anni) possono ancora crescere, poi la quota cala col passare degli anni. La «rivendita edizioni vecchie» vale dagli 11 anni in su o quando l’anno di edizione non è noto; «minima» e «massima» sono i limiti oltre cui la stima non può andare. La «massima» vale anche come tetto alla crescita delle sezioni adottanti e al passaggio di un titolo dal volume precedente.",
			"retention_example": "Un’edizione di 3 anni con quota 0,80 che l’anno scorso vendette 100 copie porta a una previsione di partenza di 80 copie.",
			"retention_title": "Quanto si rivende l’anno dopo",
			"retFloor": "Rivendita minima",
			"retMature": "Rivendita edizioni vecchie (oltre 10 anni)",
			"scorrimentoMaxOwn": "Copie proprie sotto cui affidarsi al volume precedente",
			"scorrimentoRecoverMin": "Copie del volume precedente per ereditarne la stima",
			"segClipHigh": "Correzione massima",
			"segClipLow": "Correzione minima",
			"segment_description": "Corregge la previsione in base a come sta andando l’intero settore di Mr.Book, cioè il gruppo editoriale o distributore (De Agostini, Mondadori, Zanichelli…): se i titoli di un settore vendono più o meno di quanto direbbe la sola età dell’edizione, vengono ritoccati di conseguenza. Si applica solo ai settori con abbastanza vendite da essere affidabili, e la correzione è tenuta tra un minimo e un massimo per evitare esagerazioni.",
			"segment_example": "Se i titoli di un gruppo editoriale vendono il 20% in più del previsto, un suo titolo con previsione 100 sale a 120 (fino al tetto della correzione massima).",
			"segment_title": "Correzione per settore (gruppo editoriale)",
			"segMinVol": "Copie minime del settore per correggere",
			"succActiveMin": "Copie minime del possibile sostituto",
			"succCollapseRatio": "Soglia di crollo delle vendite",
			"succDeclineFromMin": "Copie vendute un tempo (minimo)",
			"succession_description": "Individua i titoli ormai sostituiti da una nuova edizione, per non riordinare copie superate. Un titolo viene segnalato quando: vendeva bene in passato (sopra le copie minime indicate), poi è crollato oltre la soglia di crollo, ed esiste un titolo molto simile dello stesso editore, della stessa classe, ancora in vendita, che è il suo sostituto naturale. In quel caso riceve la segnalazione «Verifica edizione» con quantità azzerata: non viene riordinato da solo, decidi tu. In più, se due edizioni dello stesso titolo distano almeno gli «anni minimi per doppione» ed entrambe risultano attive, la più vecchia riceve la segnalazione «Edizione doppia»: la sua quantità viene ridimensionata sulle adozioni che le restano, e azzerata se non ne ha più.",
			"succession_example": "«Matematica.blu vol.2 (2019)» vendeva 200 copie, ora 30, e c’è «Matematica.blu vol.2 (2024)» dello stesso editore ancora in vendita → segnalato come sostituito.",
			"succession_title": "Riconoscimento di una nuova edizione",
			"succSimMin": "Somiglianza minima tra i due titoli",
			"universe_description": "Decide quali titoli entrano nella proposta e come vengono recuperati quelli che non hanno ancora vendite proprie. Entra ogni titolo ordinabile che ha venduto l’anno scorso, che è adottato, che ha un volume precedente che vende, o che ha ordini clienti non coperti da giacenza e arrivi. Restano fuori i titoli fuori catalogo o bloccati, le voci contabili e la cartoleria. Questi valori stabiliscono quando un titolo con poche vendite proprie viene stimato partendo dal volume della classe precedente oppure dall’adozione scolastica. Le «copie minime per usare un titolo nei calcoli» servono a escludere i titoli troppo piccoli, che altrimenti falserebbero le medie.",
			"universe_example": "Un volume 2 con 0 copie proprie, il cui volume 1 ne vendette 300 l’anno scorso, viene comunque proposto ereditando la stima dal volume precedente.",
			"universe_title": "Quali titoli ordinare",
			"ytdFloorCap": "Rialzo massimo sul già venduto (0 = spento)"
		},
		"unsaved": "Modifiche non salvate"
	},
	"connection": {
		"available_data": "Dati disponibili al {{date}}",
		"computer": "Computer collegato",
		"details": "Dettagli collegamento",
		"hints": {
			"blocked": "Mancano dati indispensabili: non è ancora possibile generare nuove proposte d’ordine.",
			"empty": "Le proposte d’ordine potranno essere generate dopo il primo aggiornamento completo.",
			"fresh": "Dati disponibili per le prossime proposte d’ordine.",
			"incomplete": "L’ultimo aggiornamento non ha portato tutti i dati necessari. Controlla i dettagli e riprova.",
			"loading": "Controllo dei dati disponibili da Mr.Book…",
			"partial": "Alcuni dati mancano o non sono aggiornati. Consulta i dettagli del collegamento.",
			"queued": "La richiesta è stata inviata. L’aggiornamento partirà quando il PC risponderà.",
			"stale": "I dati non sono stati verificati da più di un giorno. Aggiornali prima di generare un nuovo PO.",
			"stalled": "Controlla che il PC Mr.Book sia acceso e connesso, poi riprova.",
			"syncing": "Stiamo ricevendo i dati. Saranno disponibili al termine dell’aggiornamento.",
			"unavailable": "Non è stato possibile verificare il collegamento. Puoi continuare a consultare le proposte d’ordine.",
			"unconfigured": "Il programma di sincronizzazione non è ancora configurato sul PC di Mr.Book."
		},
		"last_full_sync": "Ultimo aggiornamento completo",
		"last_seen": "Ultimo contatto: {{date}}",
		"no_contact": "Nessun contatto ricevuto",
		"not_available": "Non disponibile",
		"refresh_busy": "Aggiornamento richiesto",
		"refresh_now": "Aggiorna dati ora",
		"retry": "Riprova",
		"states": {
			"empty": "In attesa dei primi dati",
			"fresh": "Dati aggiornati",
			"incomplete": "Aggiornamento incompleto",
			"loading": "Verifica del collegamento",
			"partial": "Dati parziali",
			"queued": "In attesa del PC",
			"stale": "Dati da aggiornare",
			"stalled": "Il PC non ha risposto",
			"syncing": "Aggiornamento in corso",
			"unavailable": "Stato non disponibile",
			"unconfigured": "Collegamento da configurare"
		},
		"subtitle": "Collegamento al gestionale",
		"title": "Collegamento con Mr.Book",
		"version": "Versione del collegamento"
	},
	"correct": {
		"confirm": "Salva correzione",
		"from": "Attuale",
		"note_help": "Spiega perché stai correggendo la proposta. Le note vengono raccolte come feedback e usate per migliorare l'algoritmo che genera le proposte d'ordine.",
		"note_label": "Note (obbligatorie)",
		"note_placeholder": "Es. adozione non confermata, ordino di meno…",
		"reset_confirm": "Ripristina proposta",
		"reset_help": "La riga tornerà alla quantità proposta dal sistema. La correzione, la motivazione e la valutazione tecnica verranno rimosse; lo storico resterà disponibile.",
		"reset_title": "Ripristina proposta",
		"same_as_proposal": "La correzione deve essere diversa dalla quantità proposta.",
		"system_proposal": "Proposta originale del sistema: {{qty}}",
		"title": "Conferma correzione",
		"to": "Nuova",
		"too_large": "La quantità supera il massimo consentito ({{max}}): hai incollato un codice?"
	},
	"corrections": {
		"campaign": "Campagna",
		"changed_to": "corretta in",
		"columns": {
			"author": "Corretta da",
			"date": "Corretta il",
			"document": "Proposta d’ordine",
			"feedback": "Motivazione della correzione",
			"notes": "Note tecniche",
			"status": "Stato",
			"title": "Titolo / ISBN"
		},
		"config": "Configurazione del",
		"conflict": "La correzione o la valutazione è cambiata. La tua bozza è conservata: ricarica i dati aggiornati prima di salvare.",
		"conflict_current": "Nel frattempo è stata salvata una valutazione {{status}} con queste note. Controllala prima di salvare la tua bozza:",
		"conflict_current_empty": "Nessuna nota tecnica.",
		"context_error": "Impossibile caricare il calcolo originale. Riprova ricaricando la pagina.",
		"description": "Le ultime correzioni alle righe dei PO, da valutare per migliorare l’algoritmo.",
		"detail": "Dettaglio correzione",
		"draft_retained": "Dati aggiornati. La tua bozza è stata conservata e puoi salvarla.",
		"empty_description": "Qui compaiono le righe corrette nei PO. Se hai applicato dei filtri, prova ad ampliarli.",
		"empty_title": "Nessuna correzione",
		"engine_context": "Contesto del calcolo originale",
		"engine_version": "Versione del motore",
		"invalid_dates": "La data finale deve essere uguale o successiva alla data iniziale.",
		"load_error": "Impossibile caricare la correzione. Riprova ricaricando la pagina.",
		"not_found": "Questa correzione non è disponibile in questa vista.",
		"notes_placeholder": "Analisi, motivo del fix o del mancato intervento, rilascio e riferimenti…",
		"open_document_new_tab": "Apri {{name}} in una nuova scheda",
		"period": "Periodo",
		"read_only": "Solo lettura. Per modificare stato e note serve il permesso Gestisci correzioni.",
		"reload": "Ricarica i valori aggiornati",
		"reset_filters": "Azzera filtri",
		"save": "Salva valutazione",
		"saved": "Valutazione salvata",
		"search": "Titolo, ISBN, motivazione o note",
		"status": {
			"ko": "KO",
			"ok": "OK",
			"pending": "Pending"
		},
		"title": "Correzioni",
		"unavailable": "Non disponibile"
	},
	"dashboard": {
		"stale_close": "Chiudi avviso",
		"stale_warning": "Attenzione: stai guardando dati di {{days}} giorni fa. Il sistema resta utilizzabile, ma le quantità potrebbero non riflettere le vendite più recenti."
	},
	"dataset": {
		"missing_required": "Mancano dati indispensabili di Mr.Book: {{list}}. Finché non arrivano non si possono generare proposte d’ordine.",
		"table_behind": "I dati di {{table}} sono fermi al {{date}}.",
		"unresolved": "I dati di {{list}} vanno rispediti da Mr.Book: chiedi al supporto un aggiornamento completo. Finché non arrivano, le proposte d’ordine non li usano."
	},
	"detail": {
		"adoption_regions": "Adozioni per regione",
		"adoption_regions_hint": "Dove sono le sezioni che hanno adottato il titolo. Il peso zone alza o abbassa la stima in base a quanto Mantegna è forte in quelle regioni.",
		"close": "Chiudi il dettaglio",
		"copies_proposed": "copie proposte",
		"corrected_to": "la tua correzione",
		"history": "Cronologia azioni",
		"history_empty": "Nessuna decisione ancora su questa riga.",
		"past_campaigns": "Campagne passate su questo titolo",
		"past_decision": "proposto {{proposed}} → deciso {{decided}}",
		"past_not_reviewed": "proposto {{proposed}} · non revisionata",
		"reasoning": "Perché questo numero"
	},
	"detail_breadcrumb": "Proposta d’ordine",
	"detail_page": {
		"adottato_missing": "Le adozioni di quest’anno non erano ancora in Mr.Book quando questa proposta d’ordine è stata generata: il contributo adozioni non è incluso.",
		"failed_title": "La generazione è fallita",
		"failed_unknown": "Errore sconosciuto",
		"generating": "Sto calcolando le proposte titolo per titolo. La pagina si aggiorna da sola: tra pochi istanti comparirà la griglia.",
		"generating_title": "Sto generando la proposta d’ordine",
		"signals_missing": "In questa proposta d’ordine mancano dati di Mr.Book: {{list}}. Il motore li ha letti come zero o li ha stimati: le quantità possono essere sbagliate.",
		"simulation_banner": "Questa è una proposta d’ordine di SIMULAZIONE a magazzino vuoto: le giacenze sono state azzerate per valutare il ragionamento. Non usarla come ordine reale."
	},
	"export": {
		"active_filters": "Filtri attivi",
		"check_history": "Controlla lo storico export prima di generare un nuovo file.",
		"delayed_title": "Il file richiede più tempo",
		"description": "Il file riflette le revisioni fatte finora, correzioni incluse, e contiene solo le righe che passano i filtri attivi qui sotto.",
		"disabled_simulation": "Le simulazioni a magazzino vuoto non si esportano: genera una proposta d’ordine normale.",
		"download_started": "Download avviato",
		"download_unavailable": "Il collegamento al file non è disponibile. Controlla lo storico export o riprova più tardi.",
		"failed": "L'export non è riuscito: riprova tra qualche minuto.",
		"failed_title": "Il download non è riuscito",
		"filter_distributor": "Distributore",
		"filter_publisher": "Editore",
		"filter_review": "Revisione",
		"filter_school_type": "Tipologia",
		"filter_search": "Ricerca",
		"generate": "Scarica file",
		"kind": "Tipo di export",
		"mrbook_description": "L'ordine include solo le righe accettate e corrette con quantità maggiore di zero. Le quantità corrette sostituiscono quelle proposte. Il filtro Revisione della tabella non si applica.",
		"mrbook_instructions": {
			"description": "Scarica il file dell'ordine e trasferiscilo sul PC dove utilizzi Mr.Book.",
			"open": "In Mr.Book: Utilità → Collegamento Terminale → Lettura Dati dal Terminale. Seleziona il TXT scaricato.",
			"open_title": "Apri la lettura da file",
			"order": "Apri Utilità → Collegamento Terminale → Ordine da Terminale e premi OK una sola volta: ripetere questa operazione può duplicare le quantità ordinate.",
			"order_title": "Crea gli ordini",
			"reading": "Completa prima eventuali letture in sospeso. Scegli Nuova Lettura, 2 prompt (separatore ;) e Lettura da file. Poi conferma con OK.",
			"reading_title": "Imposta e conferma la lettura",
			"setup": "Apri «Utilità» → «Configurazione Programma» → «Utente» → «Impostazioni». Nel campo «Terminale Barcode» imposta TERM.APP, conferma con «OK» e riavvia Mr.Book: il menu «Collegamento Terminale» comparirà automaticamente.",
			"setup_title": "Non vedi «Collegamento Terminale»?",
			"title": "Come importare in Mr.Book",
			"view": "Torna alla schermata principale e apri Ordini → Controllo ordini in essere. Qui trovi gli ordini raggruppati per distributore, insieme a quelli già presenti. L’invio ai fornitori è un passaggio successivo: l’importazione non li invia automaticamente.",
			"view_title": "Visualizza gli ordini"
		},
		"mrbook_kind": "Ordine per Mr.Book",
		"mrbook_no_filters": "Tutte le righe accettate e corrette della proposta d’ordine con quantità maggiore di zero.",
		"no_filters": "Nessun filtro attivo: l’export contiene tutta la proposta d’ordine.",
		"ready": "Export pronto: il download parte da solo",
		"remove_filter": "Rimuovi il filtro {{filter}}",
		"report_kind": "Report Excel e CSV",
		"report_ready": "Il report è pronto",
		"report_ready_description": "Ritrovi il file anche nello storico export della proposta d’ordine.",
		"still_generating": "L'export è in generazione: tra poco lo trovi nella scheda Storico export della proposta d’ordine",
		"success_title": "Come importare l’ordine in Mr.Book?",
		"title": "Esporta ordini",
		"understood": "Ho capito",
		"waiting_description": "Il download partirà automaticamente appena il file sarà pronto.",
		"waiting_title": "Prepariamo il tuo file"
	},
	"exports": {
		"all_authors": "Tutti gli admin",
		"all_statuses": "Tutti gli stati",
		"columns": {
			"actions": "Azioni",
			"document": "Proposta d’ordine",
			"generated_at": "Generato il",
			"generated_by": "Generato da",
			"id": "ID",
			"status": "Stato",
			"summary": "Contenuto"
		},
		"completed": "Pronto",
		"download_csv": "Scarica CSV",
		"download_mrbook": "Scarica ordine Mr.Book (.txt)",
		"download_xlsx": "Scarica Excel",
		"empty_description": "Gli export si generano dalla proposta d’ordine.",
		"empty_document_description": "Da questa proposta d’ordine non hai ancora generato nessun export.",
		"empty_title": "Nessun export",
		"failed": "Fallito",
		"generated_by_unavailable": "Non disponibile",
		"pending": "In generazione",
		"summary_line": "{{titles}} titoli · {{copies}} copie · {{publishers}} editori"
	},
	"grid": {
		"accept_blocked_archived": "Non puoi accettare la riga perché la proposta d’ordine è archiviata.",
		"accept_blocked_completed": "Non puoi accettare la riga perché la proposta d’ordine è completata.",
		"accept_blocked_read_only": "Non puoi accettare la riga perché la proposta d’ordine è in sola lettura.",
		"accept_short": "Accetta",
		"adoptions_title": "Sezioni che adottano il titolo: campagna scorsa e campagna in corso. Il trend è il segnale: un crollo annuncia un cambio di edizione. Clicca il numero per le regioni.",
		"all_distributors": "Tutti i distributori",
		"all_publishers": "Tutti gli editori",
		"all_reviews": "Tutti gli stati",
		"all_school_types": "Tutte le tipologie",
		"available_title": "Stock vendibile ora: giacenza meno le copie riservate (Pren.Disp + Lista di prelievo). Coincide con la Disponibilità di Mr.Book",
		"bulk_accept": "Accetta {{count}} righe",
		"bulk_accepted_one": "1 riga accettata",
		"bulk_accepted_other": "{{count}} righe accettate",
		"columns": {
			"adoptions": "Adozioni",
			"code": "ISBN",
			"corrected": "Corretta",
			"customer_orders": "Prenotazioni",
			"note": "Note",
			"pred_sold": "Venduto vol. prec.",
			"proposed": "Proposta",
			"school_type": "Tipologia",
			"sold_history": "Venduto",
			"status": "Stato",
			"stock": "Disponibile",
			"stock_real": "Giacenza",
			"supplier_orders": "Già Ordinate",
			"title": "Titolo"
		},
		"copied": "Copiato!",
		"customer_orders_title": "Copie richieste dai clienti e non ancora consegnate, comprese prenotazioni e arretrati, alla data della proposta d’ordine. Il trattino indica un dato non disponibile.",
		"empty_description": "Nessuna riga corrisponde ai filtri selezionati.",
		"empty_title": "Nessun risultato",
		"mrbook_code": "cod. {{code}}",
		"no_predecessor": "Nessun volume precedente",
		"not_bulk_selectable": "Riga già rivista: non serve riaccettarla.",
		"pred_sold_title": "Venduto del volume precedente (la classe prima di questa) negli ultimi 3 anni: la base per giudicare uno scorrimento.",
		"search_placeholder": "Cerca per titolo, ISBN o codice…",
		"sold_history_title": "Venduto degli ultimi 3 anni, dal più vecchio al più recente: gli stessi contatori dello «Storico anni prec.» della scheda Mr.Book. La colonna ordina per l'anno più recente.",
		"stock_title": "Giacenza reale a magazzino: esistenza di inizio anno più i carichi, meno scarichi e resi dell’anno",
		"supplier_orders_title": "Copie già ordinate al fornitore e non ancora arrivate (Riforn. su Mr.Book)."
	},
	"history": {
		"author_cli": "Operazione tecnica",
		"author_system": "Sistema",
		"author_unavailable": "Autore non disponibile",
		"bulk_accepted": "Accettata (in blocco)",
		"column_action": "Azioni",
		"column_author": "Autore",
		"column_date": "Data",
		"correction_reviewed": "Valutazione tecnica aggiornata",
		"empty_changes": "Nessun dettaglio aggiuntivo registrato.",
		"feedback_note": "Motivazione della correzione",
		"load_error": "Non è stato possibile caricare la cronologia.",
		"previous_feedback_note": "Motivazione precedente",
		"previous_technical_note": "Nota tecnica precedente",
		"proposal_accepted": "Accettata",
		"proposal_corrected": "Quantità corretta",
		"proposal_correction_reverted": "Proposta originale ripristinata",
		"proposal_feedback": "Nota aggiunta",
		"proposal_status": "Stato della proposta",
		"quantity": "Quantità",
		"review_status": "Valutazione tecnica",
		"technical_note": "Nota tecnica"
	},
	"index": {
		"all_statuses": "Tutti gli stati",
		"columns": {
			"campaign": "Campagna",
			"created_at": "Creata il",
			"id": "ID",
			"name": "Nome",
			"review_progress": "Revisione",
			"status": "Stato",
			"updated_at": "Ultima modifica",
			"updated_at_hint": "L’ultimo lavoro sulla proposta d’ordine: generazione, decisioni sulle righe, nome o stato. È l’ordine predefinito dell’elenco, dal più recente."
		},
		"dataset_as_of": "La proposta d’ordine userà i dati di Mr.Book aggiornati al {{date}}.",
		"dataset_date": "La proposta d’ordine userà i dati di Mr.Book del {{date}}.",
		"dataset_not_ready": "Mancano dati indispensabili di Mr.Book: la proposta d’ordine non si può generare finché non arrivano.",
		"dataset_syncing": "Aggiornamento in corso: la proposta d’ordine userà i dati del {{date}}. Se ti servono quelli nuovi, aspetta che l’aggiornamento finisca.",
		"dataset_unavailable": "Non riesco a leggere la data dei dati di Mr.Book: la proposta d’ordine userà comunque l’ultimo aggiornamento completo.",
		"distributors_all": "Tutti i distributori",
		"distributors_clear_all": "Deseleziona tutto",
		"distributors_no_match": "Nessun distributore corrisponde alla ricerca.",
		"distributors_search_placeholder": "Cerca un distributore…",
		"distributors_select_all": "Seleziona tutto",
		"distributors_selected_count": "{{count}} selezionati",
		"distributors_title": "Distributori",
		"empty_description": "Genera la tua prima proposta d'ordine per iniziare.",
		"empty_title": "Nessuna proposta d’ordine",
		"generate_document": "Genera la proposta d’ordine",
		"generation_started": "Generazione avviata: la proposta d’ordine si aggiornerà da sola",
		"horizon_biweekly": "Ogni due settimane",
		"horizon_custom": "Ogni {{days}} giorni",
		"horizon_daily": "Ogni giorno",
		"horizon_monthly": "Ogni mese",
		"horizon_weekly": "Ogni settimana",
		"mode_campagna": "Campagna",
		"mode_campagna_hint": "Il piano dell’intera stagione: il fabbisogno dell’anno residuo, da rivedere titolo per titolo e ordinare a tranche.",
		"mode_riordino": "Riordino",
		"new_document": "Nuova proposta d’ordine",
		"new_document_explainer": "La proposta d’ordine nasce dai dati di Mr.Book e va rivista titolo per titolo.",
		"no_complete_dataset": "Non ci sono ancora dati completi da Mr.Book, quindi la proposta d’ordine non si può generare. Premi «Aggiorna dati ora» nella Dashboard e riprova quando l’aggiornamento è finito.",
		"no_complete_dataset_syncing": "Non ci sono ancora dati completi da Mr.Book: potrai generare la proposta d’ordine quando l’aggiornamento in corso sarà finito.",
		"reorder_group": "Ogni quanto fai gli ordini",
		"reorder_note": "Copre le vendite del periodo più i {{lead}} giorni di consegna, e le copie dovute ai clienti: sei coperto fino al {{date}}.",
		"reviewed_of": "{{reviewed}} / {{total}}",
		"search_placeholder": "Cerca per nome…",
		"simulation_hint": "Ogni giacenza letta come zero, proposta d’ordine non esportabile.",
		"simulation_label": "Simulazione a magazzino vuoto",
		"tables_behind_effect": "Le quantità possono non tenere conto di quello che è cambiato in Mr.Book da allora.",
		"update_failed": "L’ultimo aggiornamento non è riuscito per: {{list}}. La proposta d’ordine userà i dati arrivati prima."
	},
	"page_title": "Proposte d’ordine",
	"rename": {
		"save": "Salva il nome",
		"saved": "Nome aggiornato",
		"title": "Rinomina"
	},
	"review": {
		"accepted": "Accettata",
		"corrected": "Corretta",
		"pending": "Da rivedere"
	},
	"school_type": {
		"elementari": "Elementari",
		"medie": "Medie",
		"superiori": "Superiori",
		"varia": "Varia"
	},
	"status": {
		"archived": "Archiviata",
		"completed": "Completata",
		"failed": "Fallita",
		"in_progress": "In lavorazione",
		"pending": "In coda",
		"running": "In generazione"
	},
	"tabs": {
		"corrections": "Correzioni",
		"exports": "Storico export",
		"proposals": "Proposte"
	},
	"workflow": {
		"archive": "Archivia",
		"archive_confirm": "Archivia la proposta d’ordine",
		"archive_confirm_description": "La proposta d’ordine esce dal lavoro corrente e resta consultabile in sola lettura. Non potrà più essere ripristinata.",
		"archive_confirm_description_wip": "La proposta d’ordine è ancora in lavorazione: archiviandola le righe restano come sono ora, in sola lettura, e non potrà più essere ripresa né completata. Per rilavorarla dovrai generare una nuova proposta d’ordine.",
		"archive_confirm_title": "Archiviare questa proposta d’ordine?",
		"cancel": "Annulla",
		"complete": "Completa proposta d’ordine",
		"complete_blocked": "Restano {{count}} righe da rivedere: rivedile tutte per poter completare la proposta d’ordine.",
		"complete_confirm": "Completa la proposta d’ordine",
		"complete_confirm_description": "La proposta d’ordine resta consultabile ed esportabile, ma le righe non saranno più modificabili e non potrà essere riaperta. Per rilavorarla dovrai generare una nuova proposta d’ordine.",
		"complete_confirm_title": "Completare questa proposta d’ordine?",
		"moved_to_archived": "Proposta d’ordine archiviata",
		"moved_to_completed": "Proposta d’ordine completata",
		"transition_refused": "La proposta d’ordine era già cambiata, forse in un’altra scheda: ora vedi il suo stato attuale."
	},
	"workspace": {
		"actions": "Azioni proposta d’ordine",
		"archived_read_only": "Archiviata (sola lettura)",
		"copies": "Copie proposte",
		"dataset_as_of": "Dati di Mr.Book al {{date}}",
		"dataset_as_of_hint": "La proposta d’ordine è stata generata su questi dati: un aggiornamento arrivato dopo non la cambia.",
		"flagged": "Segnalate",
		"progress": "Revisione",
		"table_behind": "Dati di {{table}} fermi al {{date}}",
		"table_behind_hint": "Questa tabella non era arrivata con l’aggiornamento usato dalla proposta d’ordine: le quantità possono non tenere conto di quello che è cambiato dopo in Mr.Book.",
		"to_review": "Da rivedere",
		"to_review_inline": "{{n}} da rivedere",
		"universe": "Titoli"
	}
}
